import React, { useState, useEffect } from 'react';
import { Button } from '@chakra-ui/react';
import * as Icon from "@phosphor-icons/react";

const SCROLL_THRESHOLD = 300; 

export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > SCROLL_THRESHOLD) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', 
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []); 


  if (!isVisible) {
    return null;
  }

  return (
    <Button
      onClick={scrollToTop}
      size="lg" 
      width="48px"
      height="48px" 
      p={0} 
      borderRadius="full" 
      position="fixed"
      bottom="65px"
      right="20px"
      zIndex="sticky" 
      bg="var(--cr-red-logo)"
      color="white"
      boxShadow="lg"
      aria-label="Scroll to Top"
      _hover={{ opacity: 0.8 }}
    >
      <Icon.ArrowUp size={24} />
    </Button>
  );
}